import { Inject, Injectable } from '@angular/core';
import { ClientManagerInstanceToken, ClientManagerInterface, ConfigService } from '@evorait/pace-core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import * as _ from 'lodash';
import moment from 'moment';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MileageModel } from '../models/mileage.model';
import { StorageMileageService } from './storage-mileage.file.service';

@Injectable({
    providedIn: 'root',
})
export class MileageService {
    private mileages: MileageModel[] = [];
    private mileageHistoryLimit: number;
    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly configService: ConfigService,
        private readonly storageMileageService: StorageMileageService,
        @Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface,
    ) {}

    public init(): Observable<MileageModel[]> {
        this.mileageHistoryLimit = this.configService.getMileageHistoryLimit();
        return this.getAllMileagesFromStorage().pipe(
            map((mileages) => {
                this.mileages = _.orderBy(mileages, 'recordedDate', 'asc');
                return this.mileages;
            }),
        );
    }

    private getAllMileagesFromStorage(): Observable<MileageModel[]> {
        return this.storageMileageService.getMileages().pipe(
            map((mileages) => this.filterMileageDetailsUsingMileageHistory(mileages)),
            catchError((err) => {
                this.log.error(`MileageService: getAllMileagesFromStorage: ERROR ->`, err);
                return of([]);
            }),
        );
    }

    public addMileage(mileage: MileageModel): Observable<MileageModel[]> {
        this.mileages.push(mileage);
        return this.storageMileageService.saveMileages(this.mileages).pipe(
            catchError((err) => {
                this.mileages.pop();
                this.log.error(`MileageService: addMileage: ERROR -> `, err);
                return of([]);
            }),
        );
    }

    public filterMileageFromDate(fromDate: moment.Moment, toDate: moment.Moment): MileageModel[] {
        return this.mileages.filter((mileage) =>
            fromDate.diff(toDate, 'days') !== 0
                ? mileage.recordedDate.isSameOrAfter(fromDate) && mileage.recordedDate.isSameOrBefore(toDate)
                : mileage.recordedDate.isSame(fromDate),
        );
    }

    private filterMileageDetailsUsingMileageHistory(mileages: MileageModel[]): MileageModel[] {
        return mileages.filter((mileage) => {
            if (mileage.recordedDate.isValid()) {
                return moment().diff(moment(mileage.recordedDate), 'days') <= this.mileageHistoryLimit;
            }
            return true;
        });
    }
}
